export const common = {
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.testimonials': 'Testimonials',
  'nav.info': 'Info',
  'nav.payment': 'Book Now',
  'nav.logo': 'Sofia & Elena',
  'nav.logoAria': 'Go to home page',
  'nav.bookConsultation': 'Book Now',
  'nav.bookConsultationAria': 'Book a consultation',
  'nav.changeLanguage': 'Change language',
  'nav.language': 'Language',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',

  'footer.brand': 'Sofia & Elena',
  'footer.tagline': 'Experts in nutritional science and cosmetology',
  'footer.navigation': 'Navigation',
  'footer.services': 'Services',
  'footer.contact': 'Contact',
  'footer.vipSupport': 'VIP Support',
  'footer.fmdProtocol': 'FMD Protocol',
  'footer.childNutrition': 'Child Nutrition',
  'footer.groupIntensive': 'Group Intensive',
  'footer.copyright': '© {{year}} Sofia & Elena. All rights reserved.',
};